import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBookmark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.75 0C2.7875 0 2 0.7875 2 1.75V14L7.25 11.375L12.5 14V1.75C12.5 0.7875 11.7125 0 10.75 0H3.75ZM9.875 6.125H8.125V7.875H6.375V6.125H4.625V4.375H6.375V2.625H8.125V4.375H9.875V6.125Z",
		fill: "currentColor"
	})
});
export default SvgIconBookmark;
